import {Component, OnInit} from '@angular/core';
import {LoadUserToEdit} from '../../../state/user.actions';
import {AppState} from '../../../../app.store';
import {Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {UserToEdit} from '../../../state/users.reducer';

@Component({
  selector: 'app-user-portfolio-edit-container',
  templateUrl: './user-portfolio-edit-container.component.html',
  styleUrls: ['./user-portfolio-edit-container.component.css']
})
export class UserPortfolioEditContainerComponent implements OnInit {
  private user$: Observable<UserToEdit>;

  constructor(private store: Store<AppState>, private route: ActivatedRoute ) { }

  ngOnInit() {
    const userId: string = this.route.snapshot.paramMap.get('userId');
    this.store.dispatch(new LoadUserToEdit(userId));
    this.user$ = this.store.select( state => {
      const userToEdit = state.user.userToEdit;
      console.log('selecting user ', userToEdit);
      return userToEdit;
    });
    const body = document.getElementsByTagName('body')[0];
    // body.classList.add('profile');
    const navbar = document.getElementsByTagName('nav')[0];
    // navbar.classList.add('navbar-transparent');
    // navbar.classList.add('bg-danger');

  }

}
